import { useNavigate } from 'react-router-dom';
import { Box, ButtonGroup } from 'components/ui';
import { useError } from 'contexts/error';
import { useFilter, initInspectionFilterValues } from 'contexts/filter';
import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { endOfDay, addDays } from 'date-fns';
import { InspectionsLink } from 'utils/link';
import InspectionFactory from 'utils/inspection';
import DashboardQuery from 'queries/user/dashboard';
import Welcome from 'components/dashboard/welcome';
import CreateInspectionButton from 'components/inspection/button/create';
import MonthlyOverview from 'components/dashboard/monthly_overview';
import PlacesAttention from 'components/dashboard/places_attention';
import InspectionSubjectAttention from 'components/dashboard/inspection_subject_attention';
import LoaderContainer from 'components/layout/loader_container';
import Container from 'components/layout/container';
import TopMenu from 'components/layout/top_menu';
import ComplianceStats from 'components/compliance_stats/container';
import { useSpace } from 'contexts/space';

const Index = () => {
  const setError = useError();
  const navigate = useNavigate();
  const { setInspectionsFilter } = useFilter();
  const inspectionFactory = InspectionFactory();
  const incomingDate = endOfDay(addDays(new Date(), 7 * inspectionFactory.PENDING_WEEKS));
  const overdueDate = endOfDay(new Date());
  const { currentSpaceId } = useSpace();

  const onOverdueClick = () => {
    setInspectionsFilter({
      ...initInspectionFilterValues,
      dueDateTo: overdueDate,
      status: 'pending',
    });
    navigate(InspectionsLink());
  };

  const onIncomingClick = () => {
    setInspectionsFilter({
      ...initInspectionFilterValues,
      dueDateTo: incomingDate,
      status: 'pending',
    });
    navigate(InspectionsLink());
  };

  const onPendingClick = () => {
    navigate(InspectionsLink());
  };

  const { data = { space: {}, inspections: {}, places: {}, inspectionSubjects: {}, initLoading: true }, loading, error } = useQuery(DashboardQuery, {
    skip: !currentSpaceId,
    onError: () => {
      setError('error.user.dashboard');
    },
  });

  return (
    <Container>
      <TopMenu />
      <LoaderContainer
        loading={loading}
        error={error}
        wrap={false}
        keepRenderedContent={!data.initLoading}
      >
        <Welcome
          user={data.user}
          placesTotal={data.space.placesTotal}
          inspectionSubjectsTotal={data.space.inspectionSubjectsTotal}
          inspectionsTotal={data.space.inspectionsTotal}
        >
          {data.space.adminRole && (
            <ButtonGroup>
              <CreateInspectionButton
                label={<FormattedMessage id="button.add.inspection" />}
                disabled={data.space.overInspectionsLimit}
              />
            </ButtonGroup>
          )}
        </Welcome>
        <ComplianceStats
          complianceRatio={data.space.complianceRatio}
          overdueInspectionsTotal={data.space.overdueInspectionsTotal}
          incomingInspectionsTotal={data.space.incomingInspectionsTotal}
          pendingInspectionsTotal={data.space.pendingInspectionsTotal}
          onOverdueClick={onOverdueClick}
          onIncomingClick={onIncomingClick}
          onPendingClick={onPendingClick}
        />
      </LoaderContainer>
        <MonthlyOverview />
      <Box sx={{ mt: 2 }}>
        <PlacesAttention />
      </Box>
      <Box sx={{ mt: 2 }}>
        <InspectionSubjectAttention />
      </Box>
    </Container>
  );
};

export default Index;
